/* tslint:disable */
/* eslint-disable */
/**
 * wicky_ups
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../Components/api/runtime';
import {
    Station,
    StationFromJSON,
    StationFromJSONTyped,
    StationToJSON,
    StationDetailAllOf,
    StationDetailAllOfFromJSON,
    StationDetailAllOfFromJSONTyped,
    StationDetailAllOfToJSON,
} from './';

/**
 * 
 * @export
 * @interface StationDetail
 */
export interface StationDetail {
    /**
     * 
     * @type {number}
     * @memberof StationDetail
     */
    stationId: number;
    /**
     * 
     * @type {string}
     * @memberof StationDetail
     */
    stationNumber: string;
    /**
     * 
     * @type {string}
     * @memberof StationDetail
     */
    stationName: string;
    /**
     * 
     * @type {number}
     * @memberof StationDetail
     */
    latitude?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StationDetail
     */
    longitude?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StationDetail
     */
    sectorId: number;
    /**
     * 
     * @type {number}
     * @memberof StationDetail
     */
    terminalType: number;
    /**
     * 
     * @type {number}
     * @memberof StationDetail
     */
    channelType: number;
    /**
     * 
     * @type {string}
     * @memberof StationDetail
     */
    area?: string;
    /**
     * 
     * @type {number}
     * @memberof StationDetail
     */
    upsInstalledCount?: number;
    /**
     * 
     * @type {number}
     * @memberof StationDetail
     */
    upsInstalledYear?: number;
    /**
     * 
     * @type {number}
     * @memberof StationDetail
     */
    upsInstalledMonth?: number;
    /**
     * 
     * @type {string}
     * @memberof StationDetail
     */
    auAdjoined?: string;
    /**
     * 
     * @type {string}
     * @memberof StationDetail
     */
    auName?: string;
    /**
     * 
     * @type {string}
     * @memberof StationDetail
     */
    phase?: string;
    /**
     * 
     * @type {string}
     * @memberof StationDetail
     */
    perfecture?: string;
    /**
     * 
     * @type {string}
     * @memberof StationDetail
     */
    municipality?: string;
    /**
     * 
     * @type {string}
     * @memberof StationDetail
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof StationDetail
     */
    building?: string;
    /**
     * 
     * @type {string}
     * @memberof StationDetail
     */
    stationStyle?: string;
    /**
     * 
     * @type {string}
     * @memberof StationDetail
     */
    powerSupply?: string;
    /**
     * 
     * @type {string}
     * @memberof StationDetail
     */
    stationType?: string;
    /**
     * 
     * @type {string}
     * @memberof StationDetail
     */
    sectorOrOmni?: string;
    /**
     * 
     * @type {string}
     * @memberof StationDetail
     */
    vendor2Plus?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StationDetail
     */
    cRanFlag?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StationDetail
     */
    keyOwner?: string;
    /**
     * 
     * @type {string}
     * @memberof StationDetail
     */
    governmentOffice?: string;
    /**
     * 
     * @type {string}
     * @memberof StationDetail
     */
    ups1?: string;
    /**
     * 
     * @type {string}
     * @memberof StationDetail
     */
    ups2?: string;
    /**
     * 
     * @type {string}
     * @memberof StationDetail
     */
    ups3?: string;
    /**
     * UPSベンダ
     * @type {string}
     * @memberof StationDetail
     */
    vendor?: string;
    /**
     * 
     * @type {number}
     * @memberof StationDetail
     */
    priority?: number | null;
    /**
     * 行動計画
     * @type {string}
     * @memberof StationDetail
     */
    actionScedule?: string;
}

export function StationDetailFromJSON(json: any): StationDetail {
    return StationDetailFromJSONTyped(json, false);
}

export function StationDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): StationDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stationId': json['stationId'],
        'stationNumber': json['stationNumber'],
        'stationName': json['stationName'],
        'latitude': !exists(json, 'latitude') ? undefined : json['latitude'],
        'longitude': !exists(json, 'longitude') ? undefined : json['longitude'],
        'sectorId': json['sectorId'],
        'terminalType': json['terminalType'],
        'channelType': json['channelType'],
        'area': !exists(json, 'area') ? undefined : json['area'],
        'upsInstalledCount': !exists(json, 'upsInstalledCount') ? undefined : json['upsInstalledCount'],
        'upsInstalledYear': !exists(json, 'upsInstalledYear') ? undefined : json['upsInstalledYear'],
        'upsInstalledMonth': !exists(json, 'upsInstalledMonth') ? undefined : json['upsInstalledMonth'],
        'auAdjoined': !exists(json, 'auAdjoined') ? undefined : json['auAdjoined'],
        'auName': !exists(json, 'auName') ? undefined : json['auName'],
        'phase': !exists(json, 'phase') ? undefined : json['phase'],
        'perfecture': !exists(json, 'perfecture') ? undefined : json['perfecture'],
        'municipality': !exists(json, 'municipality') ? undefined : json['municipality'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'building': !exists(json, 'building') ? undefined : json['building'],
        'stationStyle': !exists(json, 'stationStyle') ? undefined : json['stationStyle'],
        'powerSupply': !exists(json, 'powerSupply') ? undefined : json['powerSupply'],
        'stationType': !exists(json, 'stationType') ? undefined : json['stationType'],
        'sectorOrOmni': !exists(json, 'sectorOrOmni') ? undefined : json['sectorOrOmni'],
        'vendor2Plus': !exists(json, 'vendor2Plus') ? undefined : json['vendor2Plus'],
        'cRanFlag': !exists(json, 'cRanFlag') ? undefined : json['cRanFlag'],
        'keyOwner': !exists(json, 'keyOwner') ? undefined : json['keyOwner'],
        'governmentOffice': !exists(json, 'governmentOffice') ? undefined : json['governmentOffice'],
        'ups1': !exists(json, 'ups1') ? undefined : json['ups1'],
        'ups2': !exists(json, 'ups2') ? undefined : json['ups2'],
        'ups3': !exists(json, 'ups3') ? undefined : json['ups3'],
        'vendor': !exists(json, 'vendor') ? undefined : json['vendor'],
        'priority': !exists(json, 'priority') ? undefined : json['priority'],
        'actionScedule': !exists(json, 'actionScedule') ? undefined : json['actionScedule'],
    };
}

export function StationDetailToJSON(value?: StationDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stationId': value.stationId,
        'stationNumber': value.stationNumber,
        'stationName': value.stationName,
        'latitude': value.latitude,
        'longitude': value.longitude,
        'sectorId': value.sectorId,
        'terminalType': value.terminalType,
        'channelType': value.channelType,
        'area': value.area,
        'upsInstalledCount': value.upsInstalledCount,
        'upsInstalledYear': value.upsInstalledYear,
        'upsInstalledMonth': value.upsInstalledMonth,
        'auAdjoined': value.auAdjoined,
        'auName': value.auName,
        'phase': value.phase,
        'perfecture': value.perfecture,
        'municipality': value.municipality,
        'address': value.address,
        'building': value.building,
        'stationStyle': value.stationStyle,
        'powerSupply': value.powerSupply,
        'stationType': value.stationType,
        'sectorOrOmni': value.sectorOrOmni,
        'vendor2Plus': value.vendor2Plus,
        'cRanFlag': value.cRanFlag,
        'keyOwner': value.keyOwner,
        'governmentOffice': value.governmentOffice,
        'ups1': value.ups1,
        'ups2': value.ups2,
        'ups3': value.ups3,
        'vendor': value.vendor,
        'priority': value.priority,
        'actionScedule': value.actionScedule,
    };
}


